import React from "react";
import moment from "moment";

import { Table } from "../../../helpers";
import { DATE_FORMAT } from "../../../constants";


const PendingRequest = (props) => {
    const { pettyCash } = props

    const getRequestBody = (row) => {
        if(row.entryType === "REQUEST"){
            return row.amount
        }else{
            return "-"
        }
    }

    const getExpenseBody = (row) => {
        if(row.entryType === "EXPENSE-CASH" || row.entryType === "EXPENSE-CARD"){
            return row.amount
        }else{
            return "-"
        }
    }

    const getDateBody = (row) =>{
        return(
            moment(row.createdAt).format(DATE_FORMAT)
        )
    }

    const getTxnNoBody = (row) => {
        return(
            <div className=''>
                <p>{row.docNo}</p>
                <i className='pi pi-copy pl-2 doc-copy-icon'></i>
            </div>
        )
    }

    const getPettyCashTypeBody = (row) => {
        return row.entryType
    }


    // const getNatureOfExpenseBody = (row) => {
    //     const pettyCashId = row.pettyCashId
    //     let natureOfExpenseStrList = []
    //     let pettyCashItemCategoryIds = []
    //     pettyCashItemsData.filter((eachPettyCashItem) => {
    //         if(eachPettyCashItem.pettyCashId === pettyCashId){
    //             pettyCashItemCategoryIds.push(eachPettyCashItem.pettyCashCategoryId)
    //         }
    //     })

    //     if(pettyCashItemCategoryIds.length > 0){
    //         pettyCashItemCategoryIds.map((eachCategoryId) => {
    //             const pettyCashCategoryResult =  pettyCashCategories.find(eachCategory => eachCategory.pettyCashCategoryId === eachCategoryId)
    //             return natureOfExpenseStrList.push(pettyCashCategoryResult.pettyCashCategoryName)
    //         })
    //         return natureOfExpenseStrList.join(", ")
    //     }
    //     else{
    //         return ""
    //     }
    // }



    const tableColumns = [
        {
            header: 'Petty Cash No.', field: 'docNo' , body: getTxnNoBody
        },
        {
            header: 'CreatedAt', field: 'createdAt', body: getDateBody 
        },
        {
            header : 'PettyCashType', field : 'entryType', body: getPettyCashTypeBody
        },
        {
            header: 'Request', field: 'request', body: getRequestBody
        },
        // {
        //     header: 'Expense', field: 'expense', body: getExpenseBody
        // },
        // {
        //     header: 'Nature Of Expense', field: 'natureOfExpense'
        // },
        // {
        //     header: 'Description', field: 'description'
        // },
        // {
        //     header: 'VP No / SPO No', field: ''
        // },
        // {
        //     header: 'ApprovedBy', field: ''
        // },
        // {
        //     header: 'Booking Status', field: ''
        // },
    ]

    return (
        <>
            <Table 
                tableColumns={tableColumns}
                data={pettyCash}
            />
        </>
    )
}


export default PendingRequest